import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Slider, Button, FormControlLabel, Switch } from '@mui/material';
import CentralCalls from '../../centralCalls';
function EditTeamForm({ open, onClose, teamName, inactive, isPrimary, team_oid, onSave, hexColorCode }) {
    const [name, setName] = useState(teamName);
    const [inactiveState, setInactiveState] = useState(inactive);
    const [isPrimaryState, setIsPrimaryState] = useState(isPrimary);
    const [hexColorCodeState, setHexColorCodeState] = useState(hexColorCode || '#debfa6');

    useEffect(() => {
        setHexColorCodeState(hexColorCode || '#debfa6');
      }, [hexColorCode]);
  const checkForDuplicateCrew = async (crewName, employees) => {
    try {
      const employeeOids = employees.map(emp => emp.oid);
      console.log('checking dup...');
      console.log(employeeOids);
      const result = await CentralCalls.callStoredProcedureWithParams('sp_checkExistingCrewUpdate', { teamName: crewName, oid: team_oid }); 
      console.log('dup check result:', result);
      return result && result.length > 0;
    } catch (error) {
      console.error('Error checking for duplicate crew:', error);
      return true;
    }
  };
    const handleSave = async () => {
        try {
            const updateData = {
                name: name,
                inactive: inactiveState,
                is_primary: isPrimaryState,
                oid: team_oid,
                hex_color_code: hexColorCodeState
            };
            console.log('Updating team with data:', updateData);
            const isDuplicate = await checkForDuplicateCrew(name, []);
            if (isDuplicate) {
              alert('A crew with this name already exists');
              return;
            }
            // Update the team in the database
            const result = await CentralCalls.upsertData(updateData, 'employee_team', 'update');
            // Call the onSave callback if provided
            if (typeof onSave === 'function') {
                console.log('Calling onSave callback');
                await onSave();
                onClose(teamName, hexColorCodeState, inactiveState, isPrimaryState);
            } else {
                console.warn('No onSave callback provided');
            }
        } catch (error) {
            console.error('Error updating team:', error);
            // Optionally show an error message to the user
        } finally {
            console.log('calling onClose');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Edit Team</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Team Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    fullWidth
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={inactiveState}
                            onChange={(e) => setInactiveState(e.target.checked)}
                        />
                    }
                    label="Inactive"
                />
                <FormControlLabel
                    control={
                        <Switch
                            checked={isPrimaryState}
                            onChange={(e) => setIsPrimaryState(e.target.checked)}
                        />
                    }
                    label="Primary"
                />
                <label>
                    Team Color:
                    <input
                        type="color"
                        value={hexColorCodeState}
                        onChange={(e) => setHexColorCodeState(e.target.value)}
                        style={{ marginLeft: '10px', verticalAlign: 'middle' }}
                    />
                    <span style={{ marginLeft: '10px' }}>{hexColorCodeState}</span>
                </label>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EditTeamForm;
